<template>
    <component
        :is="tag"
        v-html="text"
    />
</template>

<script>
export default {
    props: ["field"],

    computed: {
        tag() {
            if (!this.field) return "h2";
            return this.field.tag || "h2";
        },

        text() {
            if (!this.field) return "";
            return this.field.text || "";
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Heading.vue